import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Collapse, Row, Col, Button } from 'antd';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';

import { TextField, SelectField } from '../../atoms';
import { ClassificatorField } from '../../atoms/reduxForms';
import {
  meteringPointFilterFields,
  METERING_POINT_FILTER_FORM,
} from '../../constants/formConsumptionPointFilter';
import {
  getRole,
  getIsUserProducer,
  getIsUserSeller,
} from '../../reducers/userReducer';
import { isAdmin } from '../../utils/roles';
import * as actions from '../../actions/actionCreators/consumptionPointListActionCreators';
import { gas } from '../../constants/meteringPoint';
import {
  AutoCompleteCompaniesField,
  AutoCompleteConsumersField,
  FormActions,
  SearchLegalEntityConsumersField,
} from '../../components';
import { updateFormState } from '../../reducers/reactFinalFormReducer';
import FormStateToRedux from '../FormStateToRedux';

const { Panel } = Collapse;

export class MeteringPointFilter extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    userRole: PropTypes.string.isRequired,
    isUserProducer: PropTypes.bool.isRequired,
    isUserSeller: PropTypes.bool.isRequired,
    // actions
    searchConsumptionPoints: PropTypes.func.isRequired,
    updateFormState: PropTypes.func.isRequired,
  };

  onClear = (form) => {
    form.restart({});
    this.props.updateFormState(METERING_POINT_FILTER_FORM, { values: {} });
    this.props.searchConsumptionPoints();
  };

  onSubmit = () => {
    const { searchConsumptionPoints } = this.props;
    searchConsumptionPoints();
  };

  render() {
    const { t, userRole, isUserProducer, isUserSeller } = this.props;

    const isUserAdmin = isAdmin(userRole);
    return (
      <Collapse>
        <Panel key="filters" header={t('filter.title')}>
          <Form
            initialValues={{}}
            onSubmit={this.onSubmit}
            render={({ handleSubmit, form }) => (
              <form onSubmit={handleSubmit}>
                <FormStateToRedux form={METERING_POINT_FILTER_FORM} />

                <Row gutter={32}>
                  {(isUserProducer || isUserAdmin) && (
                    <Col span={8}>
                      <Field
                        label={t('filter.type')}
                        name={meteringPointFilterFields.TYPE}
                        component={ClassificatorField}
                        classificatorType={
                          ClassificatorField.types.meteringPointType
                        }
                        hasFeedback={false}
                      />
                    </Col>
                  )}

                  <Col span={8}>
                    <Field
                      label={t('filter.dataSource')}
                      name={meteringPointFilterFields.DATA_SOURCE}
                      component={ClassificatorField}
                      classificatorType={
                        ClassificatorField.types.meteringPointDataSource
                      }
                      hasFeedback={false}
                    />
                  </Col>

                  <Col span={8}>
                    <Field
                      label={t('filter.gas.title')}
                      name={meteringPointFilterFields.GAS}
                      component={SelectField}
                      options={[
                        {
                          value: gas.HYDROGEN,
                          label: t('filter.gas.hydrogen'),
                        },
                        {
                          value: gas.BIOMETHANE,
                          label: t('filter.gas.biomethane'),
                        },
                        {
                          value: gas.LIQUID_BIOMETHANE,
                          label: t('filter.gas.liquidBiomethane'),
                        },
                      ]}
                      hasFeedback={false}
                    />
                  </Col>
                </Row>

                <Row gutter={32}>
                  <Col span={8}>
                    <Field
                      label={t('filter.eicz')}
                      name={meteringPointFilterFields.EICZ_CODE}
                      component={TextField}
                      hasFeedback={false}
                    />
                  </Col>

                  {isUserAdmin && (
                    <Col span={8}>
                      <Field
                        label={t('filter.owner')}
                        name={meteringPointFilterFields.OWNER_ID}
                        component={AutoCompleteCompaniesField}
                        hasFeedback={false}
                      />
                    </Col>
                  )}

                  <Col span={8}>
                    <Field
                      label={t('filter.consumer')}
                      name={meteringPointFilterFields.CONSUMER_ID}
                      component={
                        isUserSeller && !isUserAdmin
                          ? SearchLegalEntityConsumersField
                          : AutoCompleteConsumersField
                      }
                      hasFeedback={false}
                    />
                  </Col>
                </Row>

                <Row gutter={32}>
                  <Col span={8}>
                    <Field
                      label={t('filter.status')}
                      name={meteringPointFilterFields.STATUS}
                      component={ClassificatorField}
                      classificatorType={
                        ClassificatorField.types.meteringPointStatus
                      }
                      hasFeedback={false}
                    />
                  </Col>
                </Row>

                <FormActions>
                  <Button onClick={() => this.onClear(form)}>
                    {t('filter.clearBtn')}
                  </Button>
                  <Button type="primary" htmlType="submit">
                    {t('filter.submitBtn')}
                  </Button>
                </FormActions>
              </form>
            )}
          />
        </Panel>
      </Collapse>
    );
  }
}

const mapStateToProps = (state) => ({
  userRole: getRole(state),
  isUserProducer: getIsUserProducer(state),
  isUserSeller: getIsUserSeller(state),
});

const mapDispatchToProps = {
  ...actions,
  updateFormState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MeteringPointFilter);
